import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || '';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || '';

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Database types
export type Tables = {
  matches: {
    Row: {
      id: string;
      match_id: string;
      home_team: string;
      away_team: string;
      home_team_id: string;
      away_team_id: string;
      competition: string;
      competition_id: string;
      status: string;
      utc_date: string;
      score_home: number | null;
      score_away: number | null;
      corners: any | null;
      yellow_cards: any | null;
      red_cards: any | null;
      shots: any | null;
      updated_at: string;
    };
    Insert: Omit<Tables['matches']['Row'], 'id' | 'updated_at'>;
    Update: Partial<Tables['matches']['Insert']>;
  };
  predictions: {
    Row: {
      id: string;
      match_id: string;
      over_0_5: string;
      over_1_5: string;
      over_2_5: string;
      over_3_5: string;
      under_2_5: string;
      both_teams_to_score: string;
      total_cards_over_2_5: string;
      total_corners_over_8_5: string;
      created_at: string;
      home_team_stats: any | null;
      away_team_stats: any | null;
    };
    Insert: Omit<Tables['predictions']['Row'], 'id' | 'created_at'>;
    Update: Partial<Tables['predictions']['Insert']>;
  };
};
